import { Card, Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import "./FileImportTools.scss";
import DownloadTemplate from "./DownloadTemplate";
import FileImport from "./FileImport/FileImport";
import FileImportHistory from "./FileImportHistory";

export default function FileImportTools() {
  return (
    <div className="space-y-4 file-import-tool">
      <Card body className="shadow-none quote-container">
        <h3>
          <FormattedMessage
            id="settings.fileImportTools.fileImportHistory.fileImportTool"
            defaultMessage="File Import Tool"
          />
        </h3>
      </Card>
      <Row>
        <Col lg={7}>
          <DownloadTemplate />
        </Col>
        <Col lg={5} className="pl-lg-0">
          <FileImport />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FileImportHistory />
        </Col>
      </Row>
    </div>
  );
}
